<template>
<div>
  <v-divider
    class="mx-4"
    inset
    vertical
  ></v-divider>
  <h3>ข้อมูลเครือ</h3>
  <div class="form-group" v-for="(input,k) in inputs" :key="k">
    <v-layout class="row">
        <v-col cols="8" class="form-control">
        <v-text-field
          dense
          label="ชื่อเครือ"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="2" class="form-control">
        <v-btn icon color="green" class="add_button">
          <v-icon @click="add(k)" v-show="k == inputs.length-1">mdi-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="2" class="form-control">
        <v-btn icon color="red" class="add_button">
          <v-icon @click="remove(k)" v-show="k || ( !k && inputs.length > 1)">mdi-delete</v-icon>
        </v-btn>
      </v-col>
      </v-layout>
  </div>
</div>
</template>
<script>
export default {
  data () {
    return {
      inputs: [{
        name: '',
        party: ''
      }]
    }
  },
  methods: {
    add () {
      this.inputs.push({
        name: '',
        party: ''
      })
      // console.log(this.inputs)
    },
    remove (index) {
      this.inputs.splice(index, 1)
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>
